import NewsletterPopup from './homepage/newsletterPopup';

document.addEventListener('DOMContentLoaded', () => {
    NewsletterPopup.init();
});
